module.exports = __webpack_public_path__ + "9b63d9637405200a9eb3dc38bc1c631c.svg";